// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Martinique */
const MQ = /^(?:(?:69[67]\d\d|7091[0-3])\d{4})$/;

export default MQ;
